import { render, staticRenderFns } from "./TelephoneIcon.vue?vue&type=template&id=02ec5d56"
import script from "./TelephoneIcon.vue?vue&type=script&lang=js"
export * from "./TelephoneIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports